import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { id: "title" }
const _hoisted_3 = { class: "no_transform" }
const _hoisted_4 = { class: "locatieInfo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "no_transform" }, "Startpunt", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "trail" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h4", { class: "no_transform" }, "Introductie", -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "colofon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentTrail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.currentTrail.name), 1),
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.currentTrail.displayDistance), 1),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              innerHTML: _ctx.currentTrail.locatieInfo
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", {
            id: "description",
            innerHTML: _ctx.currentTrail.intro
          }, null, 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currentTrail.colofon), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}